import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { generateQuickInviteLink } from '@src/api/endpoints/webinar';
import { IQuickInvitePayload, IQuickInviteResponse } from '@src/webinar/types';

type TQuickInviteError = {
  response?: {
    data?: {
      error?: string;
      message?: string;
    };
    status?: number;
  };
  message?: string;
};

const useQuickInviteLink = () =>
  useMutation<IQuickInviteResponse, TQuickInviteError, IQuickInvitePayload>({
    mutationFn: generateQuickInviteLink,
    onError: (error) => {
      const message = error?.response?.data?.error || error?.response?.data?.message || error?.message || 'Failed to generate invite link.';
      toast.error(message, { icon: false });
    },
  });

export default useQuickInviteLink;

